import React from "react";
import { BasicContents } from "./BasicContents";
import {
  getDataByGas,
  getDataByGasType,
} from "../../Functions/APIservice/gasAPI";
import { CircularProgress } from "@mui/material";

type BasicPagesType = {
  part: string;
  SubParts: string[];
  select: string;
  title: string;
  PartInfo: string;
  KeyWords: string;
  MoviePart: string;
  isQuatro: boolean;
};

function BasicPages(props: BasicPagesType) {
  const part = props.part;
  const SubParts = props.SubParts;
  const select = props.select;
  const title = props.title;
  const PartInfo = props.PartInfo;
  const KeyWords = props.KeyWords;
  const MoviePart = props.MoviePart;
  const isQuatro = props.isQuatro;

  const [DicomDataContents, setDicomDataContents] = React.useState<
    getDataByGasType[]
  >([]);

  React.useEffect(() => {
    let abortController = new AbortController();
    getDataByGas({
      mode: "Image",
      part: part,
    }).then((response: Response) => {
      response
        .json()
        .then((docx: getDataByGasType[]) => {
          setDicomDataContents(docx);
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
    return () => {
      abortController.abort();
    };
  }, [DicomDataContents]);

  return (
    <div>
      {DicomDataContents.length > 0 ? (
        <BasicContents
          DicomData={DicomDataContents}
          SubParts={SubParts}
          selectSubPart={select}
          title={title}
          PartInfo={PartInfo}
          KeyWords={KeyWords}
          MoviePart={MoviePart}
          isQuatro={isQuatro}
        />
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress /> 
        </div>
      )}
    </div>
  );
}

export function Head() {
  return (
    <BasicPages
      part="Head"
      SubParts={["頭部"]}
      select={"false"}
      title={"頭部正常像"}
      PartInfo={
        "このページでは、頭部画像の正常像について扱います。Viewerには頭部MRI画像が描出されています。また、関連動画はMNiSTが制作した頭部の読影動画です。学習の際にお役立てください。"
      }
      KeyWords={"T2強調像、T1強調像、脳、脳動脈"}
      MoviePart={"Head"}
      isQuatro={true}
    ></BasicPages>
  );
}

export function Thorax() {
  return (
    <BasicPages
      part="Thorax"
      SubParts={["胸部"]}
      select={"false"}
      title={"胸部正常像"}
      PartInfo={
        "このページでは、胸部CT画像の正常像について扱います。Viewerには単純CT画像が描出されています。また、関連動画はMNiSTが制作した胸部CTの読影動画です。学習の際にお役立てください。"
      }
      KeyWords={
        "縦隔条件、肺野条件、甲状腺、胸腺、気管、食道、大動脈弓、上行大動脈、下行大動脈、肺動静脈、肺区域、動静脈、気管支"
      }
      MoviePart={"Thorax"}
      isQuatro={false}
    ></BasicPages>
  );
}

export function Abdomen() {
  return (
    <BasicPages
      part="Abdomen"
      SubParts={["腹部"]}
      select={"false"}
      title={"腹部正常像"}
      PartInfo={
        "このページでは、腹部画像の正常像について扱います。Viewerには腹部CTが描出されています。また、関連動画はMNiSTが制作した骨盤部の読影動画です。学習の際にお役立てください。"
      }
      KeyWords={
        "単純CT、T2強調像、T1強調像、肝臓、胆嚢、膵臓、脾臓、腎臓、胃、腸"
      }
      MoviePart={"Abdomen"}
      isQuatro={false}
    ></BasicPages>
  );
}

export function Pelvis() {
  return (
    <BasicPages
      part="Pelvis"
      SubParts={["骨盤部"]}
      select={"false"}
      title={"骨盤部正常像"}
      PartInfo={
        "このページでは、骨盤画像の正常像について扱います。Viewerには男性と女性のMRI画像が描出されています。また、関連動画はMNiSTが制作した骨盤部の読影動画です。学習の際にお役立てください。"
      }
      KeyWords={"T2強調像、T1強調像、前立腺、子宮、卵巣"}
      MoviePart={"Pelvis"}
      isQuatro={false}
    ></BasicPages>
  );
}

export function Limb() {
  return (
    <BasicPages
      part="Limb"
      SubParts={["肘", "膝", "股関節", "足関節"]}
      select={"true"}
      title={"四肢正常像"}
      PartInfo={
        "このページでは、四肢画像の正常像について扱います。Viewerには男性の膝・肘・股関節・足関節のMRI・CT画像が描出されています。また、関連動画はMNiSTが制作した四肢の読影動画です。学習の際にお役立てください。"
      }
      KeyWords={"T2強調像、T1強調像、足関節、肩関節、十字靱帯、半月板"}
      MoviePart={"Limb"}
      isQuatro={true}
    ></BasicPages>
  );
}
